import { CopyIcon } from '@radix-ui/react-icons'
import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { useProfileStore } from '@/reducers'
import { ProfileField } from './ProfileField'

export const ReferralInfo = () => {
  const { t } = useTranslation()
  const { referral } = useProfileStore()
  const [isMobile, setIsMobile] = useState(false)
  useEffect(() => {
    const updateIsMobile = () => setIsMobile(window.innerWidth <= 768)
    updateIsMobile()
    window.addEventListener('resize', updateIsMobile)
    return () => window.removeEventListener('resize', updateIsMobile)
  }, [])

  const handleCopy = () => {
    if (referral.link) {
      navigator.clipboard
        .writeText(referral.link)
        .catch(() => console.error('Failed to copy'))
    }
  }

  const formatLink = (link: string, maxLength: number) => {
    if (!link) return ''
    return (
      link
        .replace(/\s+/g, '')
        .match(new RegExp(`.{1,${maxLength}}`, 'g'))
        ?.join('\n') || ''
    )
  }

  return (
    <article className="grid gap-2" data-testid="container-referral-info">
      <div
        className="flex items-center justify-between"
        data-testid="container-referral-code"
      >
        <ProfileField
          label={t('profile.referralInfo.codeLabel')}
          value={referral.code}
          className="w-full"
        />
      </div>
      <div
        className="flex items-center justify-between"
        data-testid="container-referral-credits"
      >
        <ProfileField
          label={t('profile.referralInfo.creditsLabel')}
          value={referral.credits?.toString()}
          className="w-full"
        />
      </div>
      <div
        className="relative flex flex-col items-start"
        data-testid="container-referral-link"
      >
        <ProfileField
          label={t('profile.referralInfo.linkLabel')}
          value={formatLink(referral.link, isMobile ? 11 : 24)}
          className="w-full whitespace-pre-wrap break-words"
        />
        <button
          onClick={handleCopy}
          className="absolute right-0 p-1 mt-2 text-blue-500 hover:text-blue-700 dark:text-blue-300 dark:invert dark:hover:text-blue-500 flex items-center"
          data-testid="btn-referral-copy"
        >
          <CopyIcon
            className="w-5 h-5 dark:invert"
            data-testid="icon-referral-copy"
          />
        </button>
      </div>
    </article>
  )
}

export default ReferralInfo
